// supabaseClient.js
import { createClient } from "@supabase/supabase-js";

const supabaseUrl = process.env.REACT_APP_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_PUBLIC_SUPABASE_ANON_KEY;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

const reportedErrors = new Map();
let installationId = "";

export const reportError = async (
    source,
    caughtError,
    context = {},
    level = "error",
) => {
    try {
        let message = "Unknown error";

        if (caughtError instanceof Error) {
            message = caughtError.message;
        } else if (typeof caughtError === "string") {
            message = caughtError;
        } else {
            try {
                message = JSON.stringify(caughtError) || String(caughtError);
            } catch {
                message = String(caughtError);
            }
        }

        message = message.slice(0, 2000);

        const key = `${source}:${message}`;
        const now = Date.now();

        if (now - (reportedErrors.get(key) || 0) < 60000) return;

        if (reportedErrors.size >= 100) {
            reportedErrors.delete(reportedErrors.keys().next().value);
        }

        reportedErrors.set(key, now);

        if (!installationId) {
            try {
                installationId = localStorage.getItem(
                    "app_error_installation_id",
                );
            } catch {}

            if (!installationId) {
                installationId =
                    window.crypto?.randomUUID?.() ||
                    `${Date.now()}-${Math.random().toString(36).slice(2)}`;

                try {
                    localStorage.setItem(
                        "app_error_installation_id",
                        installationId,
                    );
                } catch {}
            }
        }

        const { error } = await supabase.rpc("log_app_error", {
            p_installation_id: installationId,
            p_source: String(source || "unknown").slice(0, 100),
            p_message: message,
            p_stack:
                typeof caughtError?.stack === "string"
                    ? caughtError.stack.slice(0, 12000)
                    : null,
            p_level: level,
            p_context: {
                ...context,
                route: window.location.pathname,
                clientTime: new Date().toISOString(),
                build: process.env.REACT_APP_BUILD_VERSION || null,
            },
            p_device: {
                userAgent: navigator.userAgent,
                platform:
                    navigator.userAgentData?.platform ||
                    navigator.platform ||
                    null,
                language: navigator.language,
                viewport: {
                    width: window.innerWidth,
                    height: window.innerHeight,
                },
                screen: {
                    width: window.screen.width,
                    height: window.screen.height,
                    pixelRatio: window.devicePixelRatio,
                    orientation: window.screen.orientation?.type || null,
                },
                memoryGb: navigator.deviceMemory || null,
                cores: navigator.hardwareConcurrency || null,
                connection: navigator.connection?.effectiveType || null,
                online: navigator.onLine,
                webgpu: Boolean(navigator.gpu),
                webassembly: Boolean(window.WebAssembly),
                crossOriginIsolated: window.crossOriginIsolated,
            },
        });

        if (error) {
            console.warn("Error telemetry could not be sent.", error);
        }
    } catch (loggingError) {
        console.warn("Error telemetry could not be sent.", loggingError);
    }
};
